import throttle from 'lodash/throttle';

// This module fixes the header and toggles animation classes.
export const stickyHeader = () => {
	const $window = $( window );
	const $header = $( '.o__ime-form-header' );
	const $steps = $( '.steps-animation-wrapper' );
	const $form = $( '.gform_body' );

	const triggerHeight = 25;

	let animationFlag = false;

	window.addEventListener( 'scroll', throttle( () => {
		if ( $window.scrollTop() > triggerHeight ) {
			animationFlag = true;
			$header.addClass( 'active' );
			$steps.addClass( 'active' );
			$form.addClass( 'active' );
			$header.removeClass( 'deactive' );
			$steps.removeClass( 'deactive' );
			$form.removeClass( 'deactive' );
		} else if ( animationFlag ) {
			$header.addClass( 'deactive' );
			$steps.addClass( 'deactive' );
			$form.addClass( 'deactive' );
			$header.removeClass( 'active' );
			$steps.removeClass( 'active' );
			$form.removeClass( 'active' );
		}
	}), 2000 );

	const $helpIcon = $( '.js-toggle-form-description-icon' );

	// Updates the sticky steps menu position when the Form help icon is pressed.
	$helpIcon.on( 'click', () => {
		$steps.toggleClass( 'show-text' );
	});
};